export const INSTRUMENT_TYPES = {
  MEASURING: 'Средства измерения (СИ)',
  TESTING: 'Испытательное (ИО)',
  HELPING: 'Вспомогательное (ВО)'
} as const;

export type InstrumentType = typeof INSTRUMENT_TYPES[keyof typeof INSTRUMENT_TYPES]; 